var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 8.79a1 1 0 010 1.42l-9 9a1 1 0 01-.71.29h-.06a1 1 0 01-.72-.38l-4-5a1 1 0 111.56-1.24l3.3 4.12 8.21-8.21a1 1 0 011.42 0zM28 14a14 14 0 11-28 0 14 14 0 0128 0zm-2 0a12 12 0 10-24 0 12 12 0 0024 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.8db0136abf1294926fd86d25015314d2.svg";
export { ForwardRef as ReactComponent };